import * as RadixAccordion from "@radix-ui/react-accordion";
import styles from "./accordion.module.less";
import { useState } from "react";

export type TAccordionItem = {
  id: string;
  heading: string;
  content?: React.ReactNode;
  open?: boolean;
  disabled?: boolean;
};

const AccordionItem = ({ id, heading, content, disabled = false }: TAccordionItem) => {
  return (
    <RadixAccordion.Item value={id} className={styles.accordionItem}>
      <RadixAccordion.Header className={styles.accordionHeader}>
        <RadixAccordion.Trigger disabled={disabled} className={styles.accordionItemHeader}>
          <div className={styles.accordionItemHeaderInnerWrapper}>
            <span className={["h5", styles.accordionItemHeading].join(" ")}>{heading}</span>
            <span aria-hidden className={[styles.expandIcon, "ui-icon-chevron-down"].join(" ")} />
          </div>
        </RadixAccordion.Trigger>
      </RadixAccordion.Header>
      <RadixAccordion.Content className={styles.accordionContent}>
        <div className={styles.accordionContentInnerWrapper}>{content}</div>
      </RadixAccordion.Content>
      <div className={styles.divider}>
        <div />
      </div>
    </RadixAccordion.Item>
  );
};

type TAccordionProps = {
  items: Array<TAccordionItem>;
};

//add value to root if we want it to be controlled

export const Accordion = ({ items }: TAccordionProps) => {
  const openIds = items.filter((item) => item.open).map((item) => item.id);

  const [openItems, setOpenItems] = useState<string[]>(openIds);

  return (
    <RadixAccordion.Root
      className={styles.accordionRoot}
      value={openItems}
      onValueChange={(items) => {
        setOpenItems(items);
      }}
      type={"multiple"}
    >
      {items.map((item) => (
        <AccordionItem key={item.id} {...item} />
      ))}
    </RadixAccordion.Root>
  );
};

export default Accordion;
